<template>
  <v-snackbar
      v-model="visible"
      :color="bgColor"
      :timeout="timeout"
      multi-line
  >
    <div v-html="html"></div>
    <template v-slot:action="{ attrs }">
      <v-btn
          :color="closeButtonTextColor"
          text
          v-bind="attrs"
          @click="visible = false"
      >
        Zamknij
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  data() {
    return {
      visible: false,
      bgColor: 'blue darken-3',
      closeButtonTextColor: 'white',
      html: null,
      timeout: -1,
    }
  },
  mounted() {
    this.$root.$on('notify', (options) => {
      this.display(options)
    })
    this.$root.$on('notifyError', (options) => {
      let html = options.html;

      if (options.error) {
        html = this.updateErrorMessage(html, options.error);
      }

      this.display({
        ...options,
        bgColor: 'red',
        closeButtonTextColor: 'white',
        html,
      })
    })
    this.$root.$on('notifySuccess', (options) => {
      this.display({
        ...options,
        bgColor: 'green',
        closeButtonTextColor: 'white',
      })
    })
    this.$root.$on('notifyWarning', (options) => {
      this.display({
        ...options,
        bgColor: 'orange',
        closeButtonTextColor: 'black',
      })
    })
  },
  methods: {
    display(options) {
      this.bgColor = options.bgColor || 'blue darken-3'
      this.closeButtonTextColor = options.closeButtonTextColor || 'white'
      this.html = options.html
      this.timeout = options.timeout || 5000
      this.visible = true

      if (options.callback) {
        options.callback();
      }
    },
    updateErrorMessage(message, error) {
      if (error.response && error.response.data && error.response.data.errors) {
        let additionalMessages = [];

        if (error.response.data.errors.meta) {
          // "meta" is available only on development environment and contains the real cause of the error.
          additionalMessages.push(error.response.data.errors.meta.exception.message);
        } else if (
            (Array.isArray(error.response.data.errors) && error.response.data.errors.length) ||
            (typeof error.response.data.errors === 'object' && error.response.data.errors[0])
        ) {
          let responseErrors = error.response.data.errors

          if (typeof responseErrors === 'object') {
            responseErrors = Object.values(responseErrors)
          }

          for (const responseError of responseErrors) {
            additionalMessages.push(responseError.message);
          }
        }

        message += " Szczegóły poniżej:\n<br>";
        message += additionalMessages.join("\n<br>");
      } else {
        console.warn('Błąd:', error);
      }

      return message;
    }
  },
}
</script>